import React from 'react';
import { Container, Row, Col, Form, CardBody, Card } from 'reactstrap';
import NameInput from '../../common/NameInput';

const NameComponent = () => {
    return (
        <React.Fragment>
            <div className='page-content components'>
                <Container>
                    <Card>
                        <CardBody>
                            <h2 className="mb-4">Name Input Showcase</h2>
                            <Form className="item-creation">
                                {/* First Row */}
                                <Row className="mb-4">
                                    <Col lg={6}>
                                        <NameInput
                                            name="nameWithHelp"
                                            id="nameWithHelpInput"
                                            required={true}
                                            layout="below"
                                            showHelp={true}
                                            helpText="Please enter your full name."
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                            <pre>
                                                {`
<NameInput
    name="nameWithHelp"
    id="nameWithHelpInput"
    required={true}
    layout="below"
    showHelp={true}
    helpText="Please enter your full name."
/>
                                                `}
                                            </pre>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Second Row */}
                                <Row className="mb-4">
                                    <Col lg={6}>
                                        <NameInput
                                            name="inlineName"
                                            id="inlineNameInput"
                                            label="Inline Name"
                                            required={true}
                                            layout="inline"
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                            <pre>
                                                {`
<NameInput
    name="inlineName"
    id="inlineNameInput"
    label="Inline Name"
    required={true}
    layout="inline"
/>
                                                `}
                                            </pre>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Third Row */}
                                <Row className="mb-4">
                                    <Col lg={6}>
                                        <NameInput
                                            name="optionalName"
                                            id="optionalNameInput"
                                            label="Optional Name"
                                            placeholder="Enter your name (optional)"
                                            required={false}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                            <pre>
                                                {`
<NameInput
    name="optionalName"
    id="optionalNameInput"
    label="Optional Name"
    placeholder="Enter your name (optional)"
    required={false}
/>
                                                `}
                                            </pre>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Fourth Row */}
                                <Row className="mb-4">
                                    <Col lg={6}>
                                        <NameInput
                                            name="customValidationName"
                                            id="customValidationNameInput"
                                            required={true}
                                            validationErrorMessage="Please use only letters."
                                            layout="below"
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                            <pre>
                                                {`
<NameInput
    name="customValidationName"
    id="customValidationNameInput"
    required={true}
    validationErrorMessage="Please use only letters."
    layout="below"
/>
                                                `}
                                            </pre>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default NameComponent;
